import { addSpotifyPlaylist } from "../../firebase/FirebaseFunctions";
import { db } from "../../firebase/FirebaseConfig";
import { useState } from "react";
import { TextField } from "@mui/material";
import { specialSpotifyPlaylist } from "../../firebase/models";

export default function SpotifyPlaylistEntry() {
  const [playlistName, setPlaylistName] = useState("");
  const [specialPlaylistLink, setSecialPlaylistLink] = useState("");
  const [specialPlaylistMadeByName, setSpecialPlaylistMadeByName] =
    useState("");

  const handleSpecialPlaylistSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const newPlaylist = new specialSpotifyPlaylist(
      playlistName,
      specialPlaylistLink,
      specialPlaylistMadeByName
    );
    await addSpotifyPlaylist([newPlaylist]);
    setPlaylistName("");
    setSecialPlaylistLink("");
    setSpecialPlaylistMadeByName("");
  };

  return (
    <div className="faq">
      <h1
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        POST NEW SPECIAL SPOTIFY PLAYLISTS
      </h1>
      <form onSubmit={handleSpecialPlaylistSubmit}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <input
            type="text"
            placeholder="playlistName"
            value={playlistName}
            onChange={(e) => setPlaylistName(e.target.value)}
            required
            style={{ padding: 10, margin: 10 }}
          />
          <input
            type="text"
            placeholder="specialPlaylistLink"
            value={specialPlaylistLink}
            onChange={(e) => setSecialPlaylistLink(e.target.value)}
            required
            style={{ padding: 10, margin: 10 }}
          />
          <input
            type="text"
            placeholder="specialPlaylistMadeByName"
            value={specialPlaylistMadeByName}
            onChange={(e) => setSpecialPlaylistMadeByName(e.target.value)}
            required
            style={{ padding: 10, margin: 10 }}
          />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: 20,
          }}
        >
          <button
            type="submit"
            style={{
              padding: 10,
              backgroundColor: "lightgray",
              borderRadius: 100,
              borderWidth: 0,
            }}
          >
            SUBMIT NEW SPECIAL SPOTIFY PLAYLIST
          </button>
        </div>
      </form>
    </div>
  );
}
